<a
  [routerLink]="routerLink$ | async"
  [queryParams]="{ messageKey: 'wishlists' }"
  rel="nofollow"
  class="item-count-container"
>
  <!-- <fa-icon class="header-icon" [icon]="['fas', 'heart']"></fa-icon> -->
  <span class="icon-heart"></span>

  @if (preferredWishlist$ | async; as wishlist) {
  <span class="badge badge-pill">{{ wishlist.itemsCount }}</span>
  }
  <span class="d-md-none custom-wishlist-text">{{ 'account.wishlists.link' | translate }}</span>
</a>
